<template functional>
  <Component
    :is="$options.components.MuiButtonLink"
    v-if="props.showAction"
    square
    type="black"
    icon-side="right"
    @click.native="props.startDeactivation"
  >
    <div
      :class="`icons-${props.isActivated ? 'cross' : 'check'}`"
      style="font-size: 90px;"
    />
  </Component>
</template>
<script>
import { MuiButtonLink } from '@ubeeqo/motion-ui';

export default {
  components: {
    MuiButtonLink,
  },
  props: {
    showAction: { type: Boolean, default: false },
    startDeactivation: { type: Function, default: () => {} },
    isActivated: { type: Boolean, default: false },
  },
};
</script>
